import { render, staticRenderFns } from "./ContentSectionList.vue?vue&type=template&id=3ba28ce8&"
import script from "./ContentSectionList.vue?vue&type=script&lang=js&"
export * from "./ContentSectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports